<template>
    <div class="popup visible" id="export-popup">
        <div class="popup-box">
            <p class="h2 title">Save file to XLS?</p>
            <p>{{fileName}}</p>
            <div class="buttons-box">
                <span class="btn success no-bg" @click.prevent="closeDialog">
                    <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-cross-2/></icon-base>
                    <span>NO</span>
                </span>
                <span class="btn success" @click.prevent="confirmClick">
                    <icon-base width="21" height="21" viewBox="0 0 21 21"><icon-check/></icon-base>
                    <span>YES</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import IconBase from "./IconBase";
import IconCross2 from "./icons/IconCross2";
import IconCheck from "./icons/IconCheck";
import dateformat from "dateformat"

export default {
    name: 'save-dialog',

    components: { IconCheck, IconCross2, IconBase },
    data() {
        return {
            fileName: ''
        }
    },
    computed: {
        ...mapState({
            popupData: state => state.popupData,
        }),
    },

    methods: {
        ...mapMutations([
            'switchPopup',
        ]),
        confirmClick() {
            this.popupData.func(this.fileName).then(() => {
                this.switchPopup(false);
            });
        },
        closeDialog() {
            this.switchPopup(false);
        },
    },
    mounted() {
        this.fileName = 'LX Terminals_' + dateformat(new Date(), 'dd.mm.yyyy') + '.xlsx'
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
